import axios from 'axios'

/**
 * Generic API handler. All axios call should go through here
 *
 * @param {String}   method  HTTP method (ie: GET, POST, PUT, DELETE)
 * @param {String}   url     API endpoint url
 * @param {Object}   data    Form data to submit
 *
 */

async function API (method, url, data) {
  const baseURL = location.protocol + '//' + location.hostname + ':' + location.port
  const prefix = '/api'

  const axiosObject = Object.assign({
    method,
    baseURL,
    timeout: 30000,
    url: prefix + url
  }, (method === 'get' ? { params: data } : { data: data }))

  try {
    const response = await axios(axiosObject)
    return response
  } catch (e) {
    return e
  }
}

export default API
